import { render } from "./Niif.vue?vue&type=template&id=ca90e1e2&scoped=true"
import script from "./Niif.vue?vue&type=script&lang=js"
export * from "./Niif.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Niif.vue?vue&type=style&index=1&id=ca90e1e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca90e1e2"]])

export default __exports__